import React, { Component } from 'react';
import PaypalExpressBtn from 'react-paypal-express-checkout';
import '../../style';


class Subscription extends Component {
    constructor (props) {
        super(props)
        this.state = {
            amount: props.route.match.params.cost
        } 
    }
    onSuccess = (payment) => {
        // Congratulation, it came here means everything's fine!
        var paymentId = payment.paymentID;
            var payerId = { payer_id: payment.payerID };

            // paypal.payment.execute(paymentId, payerId, function(error, payment){
            // if(error){
            //     console.error(JSON.stringify(error));
            // } else {
            //     if (payment.state == 'approved'){
            //     console.log('payment completed successfully');
            //     } else {
            //     console.log('payment not successful');
            //     }
            // }
            // });
                console.log("The payment was succeeded!", payment);
                // You can bind the "payment" object's value to your state or props or whatever here, please see below for sample returned data
    }

    onCancel = (data) => {
        // User pressed "cancel" or close Paypal's popup!
        console.log('The payment was cancelled!', data);
        // You can bind the "data" object's value to your state or props or whatever here, please see below for sample returned data
    }

    onError = (err) => {
        // The main Paypal's script cannot be loaded or somethings block the loading of that script!
        console.log("Error!", err);
        // Because the Paypal's main script is loaded asynchronously from "https://www.paypalobjects.com/api/checkout.js"
        // => sometimes it may take about 0.5 second for everything to get set, or for the button to appear
    }
    onAuthorize = (data, actions) => {
        console.log('The payment was cancelled!', data, actions);

    }
    render(routes) {
        const env = 'sandbox'; // you can set here to 'production' for production
        const currency = 'USD'; // or you can set this value from your props or state
        const total = 0.1;
        const client = {
            sandbox:    'Aa7g2h5PTme-N7kvWerwI3IrFruAVupHZUYcdYXgddaBBLNff8gmuUqkgJsGNC-RFUQqbO8XZpMlZqex',
            production: 'YOUR-PRODUCTION-APP-ID',
        }
        return (
            <div className="subscription">
                <PaypalExpressBtn env={env} client={client} currency={currency} total={total} onError={this.onError}
                onSuccess={this.onSuccess} onCancel={this.onCancel} onAuthorize={this.onAuthorize}/>
            </div>
        );
    }
}
export default Subscription;


// WEBPACK FOOTER //
// ./src/components/public/ProceedSubscription.js